import axios from 'axios';
export class StripeService {
    axiosInstances;
    config;
    auth;
    stripeEndpoint = '';
    constructor(auth, axiosInstances, config) {
        this.axiosInstances = axiosInstances;
        this.config = config;
        this.auth = auth;
        this.stripeEndpoint = this.config.API.baseApiUrl + '/stripe';
        this.auth.currentAuthority.subscribe((auth) => {
            return {
                Authorization: `Bearer ${auth?.token}`,
            };
        });
    }
    get stripeEndpoints() {
        return {
            createCharge: this.stripeEndpoint + '/charge',
            createRefund: this.stripeEndpoint + '/refund',
            createSource: this.stripeEndpoint + '/source',
            customer: {
                base: this.stripeEndpoint + '/customer',
                retrieve: (customerId) => this.stripeEndpoint + `/customer/${customerId}`,
                addSource: (customerId) => this.stripeEndpoint + `/customer/${customerId}/sources`,
                deleteSource: (customerId) => this.stripeEndpoint + `/customer/${customerId}/sources`,
                getByEmail: (email) => this.stripeEndpoint + `/customer?email=${email}`,
                update: (customerId) => this.stripeEndpoint + `/customer/${customerId}`,
            },
        };
    }
    headers() {
        return {
            Authorization: `Bearer ${this.auth.currentToken}`,
        };
    }
    adminPortal = {
        charge: {
            create: async (charge) => {
                const { data } = await axios.post(this.stripeEndpoints.createCharge, charge, {
                    headers: this.headers(),
                });
                return data;
            },
        },
        customer: {
            create: async (customer) => {
                const { data } = await axios.post(this.stripeEndpoints.customer.base, customer, {
                    headers: this.headers(),
                });
                return data;
            },
            fetch: async (customerId) => {
                const { data } = await axios.get(this.stripeEndpoints.customer.retrieve(customerId), {
                    headers: this.headers(),
                });
                return data;
            },
            query: async (params) => {
                const { data } = await axios.get(this.stripeEndpoints.customer.base, {
                    headers: this.headers(),
                    params,
                });
                return data;
            },
            update: async (customerId, customer) => {
                const { data } = await axios.put(this.stripeEndpoints.customer.update(customerId), customer, {
                    headers: this.headers(),
                });
                return data;
            },
            sources: {
                create: async (customerId, source) => {
                    const { data } = await axios.post(this.stripeEndpoints.customer.addSource(customerId), source, {
                        headers: this.headers(),
                    });
                    return data;
                },
                delete: async (customerId, sourceId) => {
                    const { data } = await axios.delete(this.stripeEndpoints.customer.deleteSource(customerId), {
                        headers: this.headers(),
                        data: {
                            sourceId,
                        },
                    });
                    return data;
                },
            },
        },
    };
    waysteDashboard = {
        invoicePayment: {
            create: async (invoicePayment) => {
                const { data } = await this.axiosInstances.mainInstance.post('/stripe/hauler/invoice-payment', invoicePayment);
                return data;
            },
        },
    };
    customerPortal = {
        public: {
            invoicePayment: {
                create: async (accessLinkToken, invoicePayment) => {
                    const { data } = await this.axiosInstances.mainInstance.post(`/stripe/invoice-payment/via-token/${accessLinkToken}`, invoicePayment);
                    return data;
                },
            },
        },
        invoicePayment: {
            create: async (invoicePayment) => {
                const { data } = await this.axiosInstances.mainInstance.post('/stripe/invoice-payment', invoicePayment);
                return data;
            },
        },
        order: {
            create: async (order) => {
                const { data } = await this.axiosInstances.mainInstance.post('/stripe/order', order);
                return data;
            },
        },
        sources: {
            create: async (customerId, source) => {
                const { data } = await axios.post(this.stripeEndpoints.customer.addSource(customerId), source, {
                    headers: this.headers(),
                });
                return data;
            },
        },
    };
}
//# sourceMappingURL=Stripe.service.js.map